<template>
  <div :class="$style.resolutionContainer">
    <app-overview title="Good news!"
                  :qualify="true"
                  :class="$style.resolutionOverview">

      <template v-slot:overviewImage>
        <img src="@/assets/img/ic_cover_qualify.png" alt="Qualify" />
      </template>

      <template v-slot:overviewContent>
        <div v-if="resultTitle"
             :class="$style.resolutionResult">
          <slot name="resolutionResult"/>
        </div>

        <slot name="resolutionText" />

        <div v-if="footer" :class="$style.resolutionFooter">
          <slot name="resolutionFooter" />
        </div>
      </template>

    </app-overview>
  </div>

</template>

<script>

export default {
  props: {
    footer: {
      type: Boolean,
      default: true,
    },
    resultTitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.resolutionContainer {
  padding: 40px 0;
  min-height: 100%;
  display: flex;
  align-items: center;
}

.resolutionOverview {
  background-image: none;
}

.resolutionResult {
  background-color: $checkbox-block-color;
  border: $checkbox-block-border;
  padding: 20px 50px;
  margin-bottom: 16px;

  p {
    margin-bottom: 12px;
  }
}

.resolutionFooter {
  border-top: $resolutionFooterBorder;
  padding-top: 24px;
  font-size: 1.4rem;
  font-family: $main-font;
  font-style: italic;
  color: $main-text-color;

  p {
    font-size: 1.4rem;
    font-family: $main-font;
    font-style: italic;
    color: $main-text-color;
  }
}
</style>
